export default __webpack_public_path__ + "static/media/invite-friends-copy-icon.9f356c94.svg";